import { FileText } from 'lucide-react';

export function LoadingSplash() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-screen flex items-center justify-center bg-background"
    >
      <div className="text-center">
        <FileText
          className="h-10 w-10 text-primary mx-auto mb-4 animate-pulse"
          aria-hidden="true"
        />
        <div
          className="animate-spin h-6 w-6 border-2 border-primary border-t-transparent rounded-full mx-auto"
          aria-hidden="true"
        />
        <span className="sr-only">Loading workspace…</span>
      </div>
    </div>
  );
}
